module.exports = "<h3 class=\"simple-tile__title\">\n  <ng-content></ng-content>\n</h3>\n"